
import { Component, Vue } from 'vue-property-decorator';

import Form8ProcessHeader from "@/components/process/Form8/components/Form8ProcessHeader.vue";
import { form8StatusInfoType } from '@/types/Information/Form8';

@Component({
    components:{
        Form8ProcessHeader
    }
})
export default class CancelSubmitForm8 extends Vue {

    stepsCompleted = {} as form8StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
